import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'
import { View, SuccessMessage } from '@olxbr/design-system'
import { Button, LoadingButton } from '@olxbr/ds-core'
import BaseForm from '../BaseForm'
import Subtitle from '../../atoms/Subtitle'
import EmailChip from '../../atoms/EmailChip'
import Form from '../../atoms/Form'
import PinCode from '../../molecules/PinCode'
import TextCallout from '../../molecules/TextCallout'

const Content = styled(View)`
  display: flex;
  flex: 1;
  flex-direction: column;
`

const HelpText = styled(Subtitle)`
  margin-top: 10px;
`

const EmailChipWrapper = styled(View)`
  display: flex;
  justify-content: center;
  margin-top: 8px;
  margin-bottom: 32px;
`

const ButtonWrapper = styled(View)`
  margin-top: 32px;
  margin-bottom: 16px;
`

const FormContent = styled(Form)`
  display: flex;
  flex-direction: column;
  width: 100%;
`

class PinCodeValidationBaseTemplate extends BaseForm {
  constructor(props) {
    super(props)
    this.state = {
      resendCount: 0,
      isSubmitting: false,
      isResending: false,
      showResendCodeSuccessMessage: false,
      validators: {
        pincode: {
          action: null,
          message: '',
        },
      },
      fields: {
        pincode: {
          valid: false,
          pristine: true,
          value: null,
        },
      },
    }
  }

  handleSubmit = event => {
    if (event) event.preventDefault()
    const { onSubmit } = this.props
    const { fields: { pincode } = {} } = this.state
    if (!pincode.valid) return
    this.setState({ isSubmitting: true })
    onSubmit(pincode.value)
      .then(() => this.setState({ isSubmitting: false }))
      .catch(() => this.setState({ isSubmitting: false }))
  }

  onPinCodeChange = (pincode, isValid) => {
    this.updateField('pincode', pincode, isValid, false, null, null)
  }

  handleResendPinCode = () => {
    const { onResend } = this.props
    this.setState({ isResending: true })
    onResend()
      .then(() =>
        this.setState(prevState => ({
          resendCount: prevState.resendCount + 1,
          isResending: false,
          showResendCodeSuccessMessage: true,
        }))
      )
      .catch(() => this.setState({ isResending: false }))
  }

  closeResendCodeSuccessMessage = () => {
    this.setState({
      showResendCodeSuccessMessage: false,
    })
  }

  render() {
    const { renderError, email, onSwitchEmail, hasError } = this.props
    const { isSubmitting, fields, isResending, resendCount, showResendCodeSuccessMessage } =
      this.state
    const { pincode } = fields
    return (
      <Content>
        {renderError()}
        <HelpText>Digite o código enviado para</HelpText>
        <EmailChipWrapper>
          <EmailChip onClick={onSwitchEmail}>{email}</EmailChip>
        </EmailChipWrapper>
        <FormContent method="POST" onSubmit={this.handleSubmit} noValidate>
          <PinCode
            disabled={isSubmitting}
            onSubmitEditing={this.handleSubmit}
            onChange={this.onPinCodeChange}
            hasError={hasError}
            pinCode={pincode}
          />
          <ButtonWrapper>
            <LoadingButton
              className="w-full"
              size="medium"
              disabled={!pincode.valid || isSubmitting}
              isLoading={isSubmitting}
              onClick={this.handleSubmit}
            >
              {isSubmitting ? 'Confirmando o código...' : 'Confirmar código'}
            </LoadingButton>
          </ButtonWrapper>
        </FormContent>
        {resendCount < 3 ? (
          <React.Fragment>
            <TextCallout
              text="Não recebeu o código?"
              linkText="Reenviar"
              onClick={this.handleResendPinCode}
              disabled={isResending}
            />
          </React.Fragment>
        ) : null}
        <SuccessMessage
          text="Código reenviado com sucesso"
          show={showResendCodeSuccessMessage}
          onClose={this.closeResendCodeSuccessMessage}
        />
      </Content>
    )
  }
}

PinCodeValidationBaseTemplate.propTypes = {
  email: PropTypes.string,
  hasError: PropTypes.bool,
  onResend: PropTypes.func,
  onSubmit: PropTypes.func,
  onSwitchEmail: PropTypes.func,
  renderError: PropTypes.func,
}

export default PinCodeValidationBaseTemplate
